import { BarChart2 } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgChartBar = mkIcon(BarChart2);
